import { fadeInBlock }  from '@ts/utils';
import { Navigation } from '@ts/components/Navigation';
import { SelectLand } from '@ts/components/SelectLand';
import { init as initDashboard } from "./dashboard";
import { init as initShop } from "./shop";
import { init as initEarnings } from "./earnings";
import { init as initParticipants } from "./participants";
import { init as initSupporters } from "./supporters";
import { init as initAddSupporters } from "./addSupporters";

export const init = () => {
    fadeInBlock();
    setPageNav();
    setSelectFilters();
    initDashboard();
    initShop();
    initEarnings();
    initParticipants();
    initSupporters();
    initAddSupporters();
}

const setPageNav = () => {
    Navigation.create('.open-page-nav', { 
        menuContainerSelector: '.page-nav-container' 
    });
}

const setSelectFilters = () => {
    SelectLand.create('#participant-status-filter', {
        prefix: 'Sort by: ',
        onChange: (value, text) => {
            console.log('make an ajax call to filter the table data here');
        }
    });
    
    SelectLand.create('#supporter-status-filter', {
        prefix: 'Sort by: ',
        onChange: (value, text) => {
            console.log('make an ajax call to filter the table data here');
        }
    });
}